import ParseHTML from "../../global/components/ParseHTML";
import { Typography } from "@mui/material";
import { useResolutionsContext } from "../hooks/useResolutionsContext";

//This component is responsible for displaying the about text for a resolution event. 
export default function AboutText() {
    const { staticText } = useResolutionsContext();
    return (
        <Typography variant="body1" component="div">
            {ParseHTML(staticText?.AboutText ?? '')}
        </Typography>
    );
}